import { render } from "./Section1.vue?vue&type=template&id=20366eb6&scoped=true"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"

import "./Section1.vue?vue&type=style&index=0&id=20366eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20366eb6"]])

export default __exports__